import { useMemo } from "react";
import { useTable } from "react-table";
import primaryComponents from "../../../primaryComponents";
import { intergratedTerminalInfo } from "../../../../localdata/intergratedTerminalInfo";
import { useGetSellmodeAssignedTerminal } from "../../../../hooks/useGetSellmodeAssignedTerminal";

export const useStoreAssignedTerminals = ({
  deviceList,
  onAssignment = () => {},
}) => {
  const { assignedTerminal, setAssignedTerminal } =
    useGetSellmodeAssignedTerminal({ onAssignment });

  const handledAssignTerminal = (id, terminal_type) => {
    setAssignedTerminal((prev) => ({ ...prev, [terminal_type]: id }));
  };

  const handledRemoveTerminal = (terminal_type) => {
    setAssignedTerminal((prev) => ({ ...prev, [terminal_type]: null }));
  };

  const columns = useMemo(
    () => [
      {
        Header: "Account Name",
        accessor: "account_name",
        Cell: ({ cell: { value } }) => value || "N/A",
      },
      {
        Header: "Provider",
        accessor: "terminal_type",
        Cell: ({ cell: { value } }) =>
          intergratedTerminalInfo?.[value]?.primaryName || "N/A",
      },
      {
        Header: "Serial Number",
        accessor: "terminal_sn",
      },
      {
        Header: "Terminal ID",
        accessor: "terminal_id",
        Cell: ({ cell: { value } }) => value || "N/A",
      },
      {
        Header: "Merchant ID",
        accessor: "merchant_id",
        Cell: ({ cell: { value } }) => value || "N/A",
      },
      {
        Header: "Action",
        Cell: ({ row }) => {
          const terminalType = row?.original?.terminal_type;
          const isAssigned = assignedTerminal?.[terminalType];

          return (
            <>
              {isAssigned && `${isAssigned}` === `${row?.original?.id}` ? (
                <primaryComponents.Button
                  classNames="btn btn--outline smallBtn"
                  onClick={() => handledRemoveTerminal(terminalType)}
                >
                  Remove from this PC
                </primaryComponents.Button>
              ) : (
                <primaryComponents.Button
                  classNames="btn btn--primary smallBtn"
                  onClick={() =>
                    handledAssignTerminal(row?.original.id, terminalType)
                  }
                >
                  Use on this PC
                </primaryComponents.Button>
              )}
            </>
          );
        },
      },
    ],
    [assignedTerminal],
  );

  const instance = useTable({ columns, data: deviceList });

  return { instance };
};
